<template>
  <DatatableReportV3
    id="memberships-sold-table"
    title="Memberships To-Do"
    download-url="/reports/memberships"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { customerClassificationColumns } from "@/lib/customerTypes";

import CONSTANTS from "@/Constants.js";
import CustomerMembershipLink from "@/MembershipModal/CustomerMembershipLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import WorkItemToggle from "@/Reports/WorkItemToggle.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[0, "desc"]],
        columns: [
          {
            data: "sold_on",
            responsivePriority: 5,
            title: "Sold On",
            searchable: false
          },
          {
            data: "invoice",
            responsivePriority: 4,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoices
          },
          { data: "job", responsivePriority: 10 },
          ...customerClassificationColumns(),
          {
            data: "customer",
            responsivePriority: 1,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers
          },
          {
            data: "service_address",
            title: "Service Address",
            responsivePriority: 6
          },
          { data: "program", searchable: false, responsivePriority: 2 },
          {
            data: "systems",
            responsivePriority: 7,
            searchable: false,
            className: "text-center",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.systems
          },
          {
            data: "payment_method_on_file",
            title: "Payment Method on File",
            filterName: "payment_method_on_file",
            orderable: false,
            searchable: false,
            responsivePriority: 11
          },
          {
            data: "department",
            responsivePriority: 9,
            filterName: "department_id",
            searchable: false,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.departments
          },
          {
            data: "technician",
            responsivePriority: 8,
            title: "Owner",
            searchable: false,
            filterName: "technician_id"
          },
          {
            data: "completed",
            responsivePriority: 3,
            title: "Complete",
            className: "text-center",
            searchable: false,
            orderable: false
          }
        ],
        vueComponents: [
          {
            rootId: "customer-membership-link-vue",
            component: CustomerMembershipLink,
            options: {
              store
            }
          },
          {
            rootId: "work-item-toggle-vue",
            component: WorkItemToggle,
            options: {
              store
            }
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
